import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CustomSelectField, CustomInputField, CustomDateField } from '../../components';
import enums from '../../constants/defaultEnums';
import translations from '../../constants/translations';

function PersonalForm({ assistanceReqConfigs }) {
  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  const collected_attributes = _.get(assistanceReqConfigs, 'data.data[0].attributes.collected_attributes');
  const address_display_type = _.get(assistanceReqConfigs, 'data.data[0].attributes.address_display_type');
  const fullAddress = address_display_type === 'full';
  const stateOnly = address_display_type === 'city_state';
  const postalCodeOnly = address_display_type === 'postal_code';
  const language = _.get(assistanceReqConfigs, 'language');

  return (
    collected_attributes ? (
      <div>
        <h3 className='personal mb-2 ui-h3-heavy'>Personal Information</h3>
        <CustomInputField
          name="first_name"
          label={_.get(translations, `${language}.firstName`)}
          id="uu_contact_first_name"
          required
          language={language}
          autoFocus
        />
        <CustomInputField
          name="last_name"
          label={_.get(translations, `${language}.lastName`)}
          id="uu_contact_last_name"
          required
          language={language}
        />
        { collected_attributes.middle_name_initial && (
        <CustomInputField
          name="middle_name_initial"
          label={_.get(translations, `${language}.middleNameInitial`)}
          id="uu_contact_middle_name"
          language={language}
        />
        )}
        { collected_attributes.title && (
        <CustomSelectField
          name="title"
          label={_.get(translations, `${language}.title`)}
          id="uu_contact_title"
          options={language == 'en' ? enums.people.titles : _.get(translations, `${language}.titles`)}
          language={language}
        />
        )}
        { collected_attributes.suffix && (
        <CustomSelectField
          name="suffix"
          label={_.get(translations, `${language}.suffix`)}
          id="uu_contact_suffix"
          options={language == 'en' ? enums.people.suffix : _.get(translations, `${language}.suffixes`)}
          language={language}
        />
        )}
        <CustomDateField
          name="date_of_birth"
          label={_.get(translations, `${language}.dateOfBirth`)}
          id="uu_contact_date_of_birth"
          other={{
            maxDate: yesterdayDate,
          }}
          required
          language={language}
        />
        { collected_attributes.phone_number && (
        <CustomInputField
          name="phone_number"
          label={_.get(translations, `${language}.phoneNumber`)}
          id="uu_contact_phone_number"
          mask="(999)-999-9999"
          language={language}
        />
        )}
        { collected_attributes.email_address && (
        <CustomInputField
          name="email_address"
          label={_.get(translations, `${language}.emailAddress`)}
          id="uu_contact_email_address"
          language={language}
        />
        )}
        { collected_attributes.address && (
          <div>
            <CustomSelectField
              name="address_type"
              id="uu_contact_address_type"
              label={_.get(translations, `${language}.addressType`)}
              options={language == 'en' ? enums.contact_data.address_types : _.get(translations, `${language}.address_types`)}
              required
              language={language}
            />

            { fullAddress && (<CustomInputField
              name="address_line1"
              id="uu_contact_address_line1"
              label={_.get(translations, `${language}.addressLine1`)}
            />)}

            { fullAddress && (<CustomInputField
              name="address_line2"
              id="uu_contact_address_line2"
              label={_.get(translations, `${language}.addressLine2`)}
            />)}

            { !postalCodeOnly && (<CustomInputField
              name="address_city"
              id="uu_contact_address_city"
              label={_.get(translations, `${language}.addressCity`)}
              required
              language={language}
            />)}

            <div className="flex">
              { !postalCodeOnly && (<div className="w-1/2 pr-8 inline-block">
                <CustomSelectField
                  name="state"
                  id="uu_state"
                  label={_.get(translations, `${language}.state`)}
                  options={enums.geography.us_states}
                  required
                  language={language}
                />
              </div>)}
              { !stateOnly && (<div className="w-1/2 inline-block">
                <CustomInputField
                  name="address_zip"
                  id="uu_contact_address_zip"
                  label={_.get(translations, `${language}.addressZip`)}
                />
              </div>)}
            </div>
          </div>
        )}
        { collected_attributes.citizenship && (
        <CustomSelectField
          name="citizenship"
          id="uu_contact_citizenship"
          label={_.get(translations, `${language}.citizenship`)}
          options={language == 'en' ? enums.people.citizenship : _.get(translations, `${language}.citizenships`)}
        />
        )}
        { collected_attributes.gender && (
        <CustomSelectField
          name="gender"
          id="uu_contact_gender"
          label={_.get(translations, `${language}.gender`)}
          options={language == 'en' ? enums.people.genders : _.get(translations, `${language}.genders`)}
        />
        )}

        { collected_attributes.marital_status && (
        <CustomSelectField
          name="marital_status"
          id="uu_contact_marital_status"
          label={_.get(translations, `${language}.maritalStatus`)}
          options={language == 'en' ? enums.people.marital_status : _.get(translations, `${language}.maritalStatuses`)}
        />
        )}

        { collected_attributes.race && (
        <CustomSelectField
          name="race"
          id="uu_contact_race"
          label={_.get(translations, `${language}.race`)}
          options={language == 'en' ? enums.people.race : _.get(translations, `${language}.races`)}
        />
        )}

        { collected_attributes.ethnicity && (
        <CustomSelectField
          name="ethnicity"
          id="uu_contact_ethnicity"
          label={_.get(translations, `${language}.ethnicity`)}
          options={language == 'en' ? enums.people.ethnicity : _.get(translations, `${language}.ethnicities`)}
        />
        )}

        { collected_attributes.gross_monthly_income && (
        <CustomInputField
          name="household_gross_monthly_income"
          id="uu_contact_household_gross_monthly_income"
          label={_.get(translations, `${language}.householdGrossMonthlyIncome`)}
        />
        )}

      </div>
    ) : ''
  );
}

PersonalForm.propTypes = {
  assistanceReqConfigs: PropTypes.object.isRequired,
};

export default PersonalForm;
